import React, { Component } from 'react';
import './HandHistory.css';
import { Label } from 'reactstrap';
import * as actions from "../../store/actions/index";
import { connect } from "react-redux";
import { apiService } from '../../common/apiCallService';
import Loading from '../Loading.js';
import { baseUrl } from '../../common/config.js';
var _ = require('underscore');
import moment from 'moment';
import i18next from 'i18next';
import { InputDatePicker } from 'mygame-components';
import $ from 'jquery';
import "./HandHistoryFilterModal.css"
import Select from 'react-select-me';
import { getColor, getDarkTextColor, getHoverColor, getTextColor } from '../../common/ThemeService';

class HandHistoryFilter extends Component {

    constructor(props) {
        super(props)
        this.state = {
            imageSrc: null,
            loading: false,
            holeCardList: [],
            ringTypes: ['All', 'Heads-up', '6-seater', 'Full Ring'],
            selectedFromDate: moment(this.props.filter.from).startOf("day"),
            selectedToDate: moment(this.props.filter.to).startOf("day"),
            showFromDatePicker: true,
            showToDatePicker: true,
            handLimitError: "", //"Over 10K hand download limit, reduce time period."
            dateError: "",
            gameTypeSelected:""
        }

    }
    componentDidMount() {
        this.setState({ holeCardList: this.props.filter.holeCards })
    }

    optionRenderer(option, selectedOptions) {
        return <div>
            <div className={"dd__option" + (option.value === selectedOptions.value ? "dd__selectedOption" : "")}
                data-e2e={`${option.label}`}>{option.label}</div>
        </div>
    }

    selectHoleCardFilter = (val) => {
        if (this.state.holeCardList.includes(val)) {
            document.getElementById(val).style.background = "white";
            for (var i = 0; i < this.state.holeCardList.length; i++) {
                if (this.state.holeCardList[i] === val) {
                    this.state.holeCardList.splice(i, 1);
                }
            }
        } else {
            document.getElementById(val).style.background = "#6cd246";
            this.state.holeCardList.push(val);
        }
        this.forceUpdate()
        let filter = this.props.filter;
        filter.holeCards = this.state.holeCardList;
        this.changeFilter(filter);
    }
    setGameType = async (e) => {
        let filter = this.props.filter;
        let prevGameType = filter.gameType;
        filter.gameType = e.target.value;
        if (e.target.value === "Spin") {
            filter.ringType = "Heads-up";
        } else if (prevGameType === "Spin") {
            filter.ringType = "All"
        }
        await this.changeFilter(filter);
        await this.props.getPlayerLevel();
    }
    setLevel = (e) => {
        let filter = this.props.filter;
        filter.level = e.target.value;
        this.changeFilter(filter);
    }
    setPosition = (e) => {
        let filter = this.props.filter;
        filter.position = e.target.value;
        this.changeFilter(filter);
    }
    onChangeHandle = (e) => {
        let filter = this.props.filter;
        filter[e.target.name] = e.target.value;
        this.changeFilter(filter);
        if(e.target.name === 'gameType'){this.setGameType(e)}
    }
    setRingType = async (e) => {
        let filter = this.props.filter;
        filter.ringType = e.target.value;
        await this.changeFilter(filter);
        await this.props.getPlayerLevel();
    }

    changeFilter = (filter, isFirstCall) => {
        if (!isFirstCall) {
            this.props.setFulfilledFlag(false)
        }
        this.props.setHandHistoryFilter(filter);
    }
    onClickSearchButton = () => {
        if (!this.props.changeFulfilled) {
            this.props.getHandHistory();
            const prevFilters = { ...this.props.filter };
            let holeCards = [];
            prevFilters.holeCards.map(data => {
                holeCards.push(data)
            })
            this.props.setHandHistoryPrevFilter({ ...this.props.filter, holeCards: holeCards })
        }
        this.props.setFulfilledFlag(true)
    }
    handleChange = (data, dateType) => {
        this.setState({
            [dateType]: data
        })
    }
    handleSave = async (dateType) => {
        if (this.state.selectedFromDate.isAfter(this.state.selectedToDate)) {
            this.setState({ dateError: i18next.t("lable.formDateNotGreaterThanTodate")})
        } else if (this.state.selectedFromDate.isAfter(moment())) {
            this.setState({ dateError: i18next.t("lable.formDateNotGreaterThanCurrentTime") })
        } else if (this.state.selectedToDate.isAfter(moment())) {
            this.setState({ dateError: i18next.t("lable.toDateNotGreaterThanCurrentTime")})
        } else if (this.state.selectedFromDate.isBefore(moment().subtract(40, 'days'))) {
            this.setState({ dateError: i18next.t("lable.fromDateshouldPast40Days")})
        } else if (this.state.selectedToDate.isBefore(moment().subtract(40, 'days'))) {
            this.setState({ dateError: i18next.t("lable.toDateshouldPast40Days")})
        } else {
            this.setState({ dateError: "" })
        }
        let filter = this.props.filter;
        filter[dateType] = (dateType === "from") ? (this.state.selectedFromDate).startOf("day").format("YYYY-MM-DDTHH:mm:ss.SSSZ").toString()
            : (this.state.selectedToDate).startOf("day").format("YYYY-MM-DDTHH:mm:ss.SSSZ").toString();
        await this.changeFilter(filter);
        await this.props.getPlayerLevel();
    }
    clearHoleCardList = () => {
        this.setState({ holeCardList: [] })
        let filter = this.props.filter;
        filter.holeCards = [];
        this.changeFilter(filter);
    }

    displayCards = (r) => {
        let rown = r
            , colN = 13
            , index = -1
            , sameSuit = false
            //   , holeCards = this.state.holeCards && Object.keys(this.state.holeCards).length > 0 && [...this.state.holeCards]
            , cells = _.range(1, colN + 1).map((i, index) => {
                let cellVal = '';
                let cards = ['A', 'K', 'Q', 'J', 'T', '9', '8', '7', '6', '5', '4', '3', '2']
                if (cards[i - 1] == cards[rown - 1]) {
                    sameSuit = true
                    cellVal = cards[rown - 1] + '' + cards[i - 1]
                }
                else if (sameSuit)
                    cellVal = cards[rown - 1] + '' + cards[i - 1] + "s"
                else
                    cellVal = cards[i - 1] + '' + cards[rown - 1] + "o"

                return (
                    <td key={index} id={cellVal + ""} data-e2e={cellVal + ""} style={{
                        border: "0.3px solid white", textAlign: "center", fontSize: "9px",
                        padding: "1px", verticalAlign: "middle", color: "#1f1e23", fontWeight: "bold", height: "23px", width: "23px", backgroundColor: this.state.holeCardList.includes(cellVal) ? "#6cd246" : "white", textAlign: "center", cursor: "pointer"
                    }} onClick={() => this.selectHoleCardFilter(cellVal)}>
                        {cellVal}
                    </td>)
            });
        return cells
    }


    render() {
        const themeColor = getColor()
        const themeTextColor = getTextColor()
        const themeDarkTextColor = getDarkTextColor()
        const themeHoverColor = getHoverColor()
        let ringTypes = this.state.ringTypes;
        return (
            <span>
                <style>{`\
                  .hand_history_clearAll:hover {\
                    background-color: ${themeHoverColor};\
                  }\
                  .hand_history_searchBtn {\
                    background-color: ${themeColor};\
                    border-color: ${themeColor};\
                    color: ${themeTextColor};\
                  }\
                  .hand_history_searchBtn_disable {\
                    background-color: #9B9B9B;\
                  }\
                  .hand_history_searchBtn:hover {\
                    background-color: ${themeColor};\
                    border-color: ${themeColor};\
                    color: ${themeTextColor};\
                    opacity: 0.8;
                  }\
                `}</style>
                {this.props.showFilterModal && <div className="HandHistoryFilterModalDialog" role="document">
                <div className="HandHistoryFilterModal_content">
                    <div className="background-handHistory hand-history-header-padding header-handHistory MH_filter_header_wrap">
                        <span className="MH_filter_title">{i18next.t("lable.Filters")}</span>
                        <span className="MH_filter_close_text">{i18next.t("lable.close")}</span>
                        <span>
                            <button
                                onClick={async (e) => {
                                    e.preventDefault();
                                    if (this.props.changeFulfilled === false) {
                                        const prevFilters = { ...this.props.prevFilter };
                                        if (this.props.filter.from != prevFilters.from || this.props.filter.to != prevFilters.to
                                            || this.props.filter.gameType != prevFilters.gameType || this.props.filter.ringType != prevFilters.ringType) {
                                            let holeCards = [];
                                            prevFilters.holeCards.map(data => {
                                                holeCards.push(data)
                                            })
                                            await this.changeFilter({ ...prevFilters, holeCards: holeCards });
                                            await this.props.getPlayerLevel(false, true);
                                            this.setState({
                                                holeCardList: holeCards,
                                                selectedFromDate: moment(prevFilters.from).startOf("day"),
                                                selectedToDate: moment(prevFilters.to).startOf("day"),
                                            })
                                            this.props.setFulfilledFlag(true)
                                        } else {
                                            let holeCards = [];
                                            prevFilters.holeCards.map(data => {
                                                holeCards.push(data)
                                            })
                                            await this.changeFilter({ ...prevFilters, holeCards: holeCards });
                                            this.setState({
                                                holeCardList: holeCards,
                                                selectedFromDate: moment(prevFilters.from).startOf("day"),
                                                selectedToDate: moment(prevFilters.to).startOf("day"),
                                            })
                                            this.props.setFulfilledFlag(true)
                                        }
                                    }
                                    this.props.setShowFilterModal(false);
                                    this.setState({ dateError: "" })
                                }}
                                className='missionbtn skillEditButton myHands_skillEditButton' 
                                style={{
                                    backgroundColor: themeColor,
                                }}>
                                <i style={{ color: themeTextColor, fontSize: "20px" }} className="fa fa-times"></i>
                            </button>
                        </span>
                    </div>
                    <div className="border-bottom-hand-history border_full_length HH_Filters_border"></div>
                    <div style={{ padding: "15px" }}>
                        {this.state.loading ? <Loading /> : null}
                        <form>
                            <div>
                                <div className="row">
                                    <div className="col-sm-6 col-lg-6 col-xs-12" >

                                        <div className="row">

                                            <div className="col-sm-12 col-lg-6 col">
                                                <div className="col-12">
                                                    <Label className="filter-title-font-hand-history">{i18next.t("lable.gameType")}</Label>
                                                    <label className="selectLabel" data-e2e="gametype">
                                                        <Select
                                                            data-e2e="gameType"
                                                            options={[
                                                                { value: 'cash', label: i18next.t("lable.CashGames") },
                                                                { value: 'tournament', label: i18next.t("lable.tournaments") },
                                                                { value: 'Spin', label: i18next.t("lable.spin")},
                                                                { value: 'SnG', label: "SitnGo" }  
                                                            ]}
                                                            optionRenderer={this.optionRenderer}
                                                            value={this.props.gameType}
                                                            onChange={(option) => { this.onChangeHandle({ target: { name: "gameType", value: option.value } }); }}
                                                        />
                                                    </label>
                                                </div>
                                                <div className="col-12">
                                                    <Label className="filter-title-font-hand-history">{i18next.t("lable.from")}: <span className="myhands_fromdate_limit_msg">({i18next.t("lable.last40Days")})</span></Label>
                                                    <label className="selectLabel" data-e2e="from">
                                                        <div className="form-control hh_cursor_pointer position_relative" id="MyHands_dp_date_picker_group1" data-toggle="modal"
                                                            data-target="#MyHnads_dpFromDateTimePicker">
                                                            <span className="myhands_datepickerText">
                                                                {moment(this.props.from).startOf("day").format("DD/MM/YYYY")}
                                                            </span>
                                                        </div>
                                                        <div className="download_from_datepicker">
                                                            <InputDatePicker
                                                                modalId="MyHnads_dpFromDateTimePicker"
                                                                selectedDate={this.state.selectedFromDate}
                                                                handleChange={(data) => { this.handleChange(data, "selectedFromDate") }}
                                                                handleSave={() => {
                                                                    this.handleSave("from");
                                                                    $('#MyHnads_dpFromDateTimePicker_close').click();
                                                                }}
                                                            />
                                                        </div>
                                                    </label>
                                                </div>
                                                <div className="col-12">
                                                    <Label className="filter-title-font-hand-history">{i18next.t("lable.to")}:</Label>
                                                    <label className="selectLabel" data-e2e="to">
                                                        <div className="form-control hh_cursor_pointer position_relative" id="MyHands_dp_date_picker_group2" data-toggle="modal"
                                                            data-target="#MyHands_dpToDateTimePicker">
                                                            <span className="myhands_datepickerText">
                                                                {moment(this.props.to).startOf("day").format("DD/MM/YYYY")}
                                                            </span>
                                                        </div>
                                                        <div className="download_to_datepicker">
                                                            <InputDatePicker
                                                                modalId="MyHands_dpToDateTimePicker"
                                                                selectedDate={this.state.selectedToDate}
                                                                handleChange={(data) => { this.handleChange(data, "selectedToDate") }}
                                                                handleSave={() => {
                                                                    this.handleSave("to");
                                                                    $('#MyHands_dpToDateTimePicker_close').click();
                                                                }}
                                                            />
                                                        </div>
                                                    </label>
                                                </div>

                                                {this.props.filter.gameType != "Spin" && <div className="col-12">
                                                    <Label className="filter-title-font-hand-history">{i18next.t("lable.seats")}</Label>
                                                    <label className="selectLabel"data-e2e="seats">
                                                        <Select
                                                            data-e2e="ringType"
                                                            options={
                                                                ringTypes.map(data => {
                                                                    return { value: data, label: data }
                                                                })
                                                            }
                                                            optionRenderer={this.optionRenderer}
                                                            value={this.props.ringType}
                                                            onChange={(option) => { this.setRingType({ target: { name: "ringType", value: option.value } }); }}
                                                        />
                                                    </label>
                                                </div>}
                                            </div>
                                            <div className="col-sm-12 col-lg-6 col">
                                                <div className="col-12">
                                                    <Label className="filter-title-font-hand-history">{i18next.t("lable.stake")}</Label>
                                                    <label className="selectLabel" data-e2e="stake">
                                                        <Select
                                                            data-e2e="level"
                                                            options={[
                                                                { value: "All Level", label: "All" },
                                                                ...(this.props.levels.map(data => {
                                                                    return { value: data, label: data }
                                                                }))
                                                            ]}
                                                            optionRenderer={this.optionRenderer}
                                                            value={this.props.level}
                                                            onChange={(option) => { this.setLevel({ target: { name: "level", value: option.value } }); }}
                                                        />
                                                    </label>
                                                </div>
                                                <div className="col-12">
                                                    <Label className="filter-title-font-hand-history">{i18next.t("lable.Position")}</Label>
                                                    <label className="selectLabel"data-e2e="Position">
                                                        <Select
                                                            data-e2e="position"
                                                            options={
                                                                ["All", "CO", "SB", "BB", "BTN", "EP", "MP"].map(data => {
                                                                    return { value: data, label: data === "All" ? "All Positions" : data }
                                                                })
                                                            }
                                                            optionRenderer={this.optionRenderer}
                                                            value={this.props.position}
                                                            onChange={(option) => { this.setPosition({ target: { name: "position", value: option.value } }); }}
                                                        />
                                                    </label>
                                                </div>
                                                <div className="col-12">
                                                    <Label className="filter-title-font-hand-history">{i18next.t("lable.sortBy")}</Label>
                                                    <label className="selectLabel"data-e2e="sort by">
                                                        <Select
                                                            data-e2e="sort"
                                                            options={[
                                                                { value: 'desc', label: i18next.t("lable.mostRecent") },
                                                                { value: 'asc', label: i18next.t("lable.oldest") },
                                                                { value: 'starred', label: i18next.t("lable.starredHands") },
                                                                { value: 'biggestWins', label: i18next.t("lable.biggestWins") },
                                                                { value: 'biggestLosses', label: i18next.t("lable.biggestLosses") },
                                                            ]}
                                                            optionRenderer={this.optionRenderer}
                                                            value={this.props.sort}
                                                            onChange={(option) => { this.onChangeHandle({ target: { name: "sort", value: option.value } }); }}
                                                        />
                                                    </label>
                                                </div>
                                                <div className="col-12">
                                                    <Label className="filter-title-font-hand-history">{i18next.t("lable.handType")}</Label>
                                                    <label className="selectLabel">
                                                        <Select
                                                            options={[
                                                                { value: 'All', label: i18next.t("lable.allHands") },
                                                                { value: 'starred', label: i18next.t("lable.starredHands")},
                                                                { value: 'booster', label: i18next.t("lable.boosterHands") },
                                                                { value: 'cashedout', label: i18next.t("lable.cashedout") }
                                                            ]}
                                                            optionRenderer={this.optionRenderer}
                                                            value={this.props.handType}
                                                            onChange={(option) => { this.onChangeHandle({ target: { name: "handType", value: option.value } }); }}
                                                        />
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-sm-6 col-lg-6 col-xs-12 padding_left_search_hands" >
                                        <Label className="filter-title-font-hand-history" style={{ display: "block" }}>{i18next.t("lable.searchHands")}</Label>
                                        <div className="holeCardMsgAndClearbutton_wrap">
                                            <div className="filter-title-font-hand-history_description">{i18next.t("lable.clickHandSearch")}</div>
                                            {this.props.holeCards && this.props.holeCards.length > 0 && <div className="hand_history_clearAll" onClick={(e) => {
                                                e.preventDefault()
                                                this.clearHoleCardList()
                                            }}data-e2e="clear"
                                            style={{
                                                borderColor: themeColor,
                                                color: themeDarkTextColor,
                                            }}
                                            >{i18next.t("lable.clear")}</div>}
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-12 col-lg-12 col hand-history-center-item">
                                                <table id="handChart" className="hand-history-hole-card-font hand-history-hole-card-table">
                                                    <tbody>
                                                        {_.range(1, 13 + 1).map((r, ind) => <tr key={ind}> {
                                                            this.displayCards(r).map(card => {
                                                                return card
                                                            })} </tr>)}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12 col-lg-9" >
                                        <div className="filterDeviderLine" />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-sm-6 col-md-6 col-lg-3" style={{ position: "relative" }}>
                                        <div
                                            className={"hand_history_searchBtn " + (this.state.dateError !== "" || this.props.changeFulfilled ? " hand_history_searchBtn_disable" : "")} data-e2e="Update Filters" onClick={(e) => {
                                                e.preventDefault()
                                                if (this.state.dateError === "" && this.props.changeFulfilled === false) {
                                                    this.onClickSearchButton()
                                                    this.props.setShowFilterModal(false);
                                                }
                                            }}>{this.state.dateError !== "" || this.props.changeFulfilled ? "Update Filters" : "Search Now"}</div>
                                        <div className="MyHandsDateError">{this.state.dateError}</div>
                                    </div>
                                </div>
                            </div></form>
                    </div>
                </div>
            </div>}</span>
        )
    }
}

const mapStateToProps = state => {
    return {
        filter: state.handHistory.filter,
        prevFilter: state.handHistory.prevFilter,
        level: state.handHistory.filter.level,
        sort: state.handHistory.filter.sort,
        handType: state.handHistory.filter.handType,
        ringType: state.handHistory.filter.ringType,
        from: state.handHistory.filter.from,
        to: state.handHistory.filter.to,
        gameType: state.handHistory.filter.gameType,
        holeCards: state.handHistory.filter.holeCards,
        position: state.handHistory.filter.position,
        lang: state.header.lang
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setHandHistoryFilter: (filter) => dispatch(actions.setHandHistoryFilter(filter)),
        setHandHistoryPrevFilter: (filter) => dispatch(actions.setHandHistoryPrevFilter(filter))
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(HandHistoryFilter);



/** WEBPACK FOOTER **
 ** ./src/components/HandHistory/HandHistoryFilter.js
 **/